export enum Environment {
    Dev = 'Dev',
    Int = 'Int',
    Ppe = 'Ppe',
    Prod = 'Prod',
}

export let ClientEnv: Environment = Environment.Dev;

const urlLocation: string = window.location.origin;

if (urlLocation.startsWith('https://purple-beach-097a83e03-int')) {
    ClientEnv = Environment.Int;
} else if (urlLocation.startsWith('https://purple-beach-097a83e03-preprod')) {
    ClientEnv = Environment.Ppe;
} else if (
    urlLocation.startsWith('https://purple-beach-097a83e03.') ||
    urlLocation.startsWith('https://warehouse.nelken.rs') ||
    urlLocation.startsWith('https://skladiste.nelken.rs') ||
    urlLocation.startsWith('https://magacin.siming.ba')
) {
    ClientEnv = Environment.Prod;
} else {
    ClientEnv = Environment.Dev;
}

export let baseUrl: string;

if (ClientEnv === Environment.Prod || ClientEnv === Environment.Ppe) {
    baseUrl = 'https://app-nelken-wh-prod.azurewebsites.net';
} else if (ClientEnv === Environment.Int) {
    baseUrl = 'https://app-nelken-wh-int.azurewebsites.net';
} else if (ClientEnv === Environment.Dev) {
    baseUrl = 'https://localhost:44357';
    //baseUrl = 'https://nelkenwarehouseproduction-fbbvaudqbtbngsc6.switzerlandnorth-01.azurewebsites.net';
} else {
    throw Error('Environment error');
}

export let warehouseClientId: string = 'df8ce342-9625-4479-bfda-12e5182a3d74'; // testing client
export let warehouseTenantId: string = '3b3490de-f806-4dae-8726-af8d1f2ec4a3'; // Nelken Tenant

if (ClientEnv === Environment.Prod) {
    warehouseClientId = '11308da5-389e-47c9-ba68-93d6eef8f92b'; // production client

    if (urlLocation.startsWith('https://warehouse.nelken.rs')) {
        warehouseTenantId = '3b3490de-f806-4dae-8726-af8d1f2ec4a3';
    }

    if (urlLocation.startsWith('https://magacin.siming.ba')) {
        warehouseTenantId = '4fae7ec9-e146-493c-9ef8-255eef2804a3';
    }
}
